import { useMemo } from 'react';
import { Box } from '@mui/material';
import { Button, Spin, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';
import { TableStatusMap } from 'pages/globals/global';
import viewIcon from 'assets/images/table-icons/view_blue.svg';
import editIcon from 'assets/images/table-icons/edit_green.svg';
import deleteIcon from 'assets/images/table-icons/delete_red.svg';
import ComptrollerDataTable from '../comptroller-table/ComptrollerDataTable';

const titleFormat = (code, name) => {
	return `${code} - ${name}`;
};

const ListViewKeyManagementArea = ({ kmaList = [], moduleList = [], existingHierarchyNameMap, isLoading, handleDelete }) => {
	const navigate = useNavigate();

	const activeInactiveStatus = (status) => {
		if (status === 'Active') {
			return (
				<Box style={{ backgroundColor: '#DBF7E2', color: '#30653D', textAlign: 'center', borderRadius: '5px', padding: '2px' }}>{status}</Box>
			);
		} else if (status === 'Inactive') {
			return (
				<Box style={{ backgroundColor: '#FFE2E2', color: '#BB2222', textAlign: 'center', borderRadius: '5px', padding: '2px' }}>{status}</Box>
			);
		} else if (status === 'W-I-P') {
			return (
				<Box style={{ backgroundColor: '#FDF7C4', color: '#694500', textAlign: 'center', borderRadius: '5px', padding: '2px' }}>{status}</Box>
			);
		}
	};

	const COLUMNS = useMemo(
		() => [
			{
				Header: 'Sl',
				accessor: (data, index) => index + 1,
			},
			{
				Header: 'KMA Name',
				accessor: 'name',
			},
			{
				Header: 'Module Name',
				accessor: 'moduleId',
				Cell: (data) => {
					const value = moduleList?.find((item) => item.code === data?.value);
					return value ? titleFormat(value?.code, value?.name) : '';
				},
			},
			{
				Header: 'Sub Module Name',
				accessor: 'subModuleId',
				Cell: (data) => {
					const subModules = moduleList?.filter((item) => item.parent === data?.row?.values?.moduleId);

					const value = subModules?.find((item) => item.code === data?.value);

					return value ? titleFormat(value?.code, value?.name) : '';
				},
			},
			{
				Header: 'KMA Parent Name',
				accessor: 'parentKAMId',
				Cell: (data) => {
					const value = kmaList?.find((item) => item.id === data?.value);
					return value ? value?.name : '';
				},
			},
			{
				Header: 'KMA Code',
				accessor: 'code',
			},
			{
				Header: 'Status',
				accessor: (data) => {
					return TableStatusMap[data?.activationStatus];
				},
				Cell: (cell) => {
					return activeInactiveStatus(TableStatusMap[cell.row.original.activationStatus]);
				},
				align: 'center',
				cellAlign: 'center',
			},
			{
				Header: 'Action',
				Cell: (cell) => (
					<div style={{ textAlign: 'center' }}>
						<Tooltip title="View">
							<Button
								type="text"
								icon={<img src={viewIcon} width={16} height={16} alt="view" />}
								onClick={(e) => {
									e.stopPropagation();
									navigate('/comptroller/key-management-area/details', {
										state: { existingHierarchyNameMap, kmaDetails: cell.row.original, kmaList },
									});
								}}
							></Button>
						</Tooltip>
						<Tooltip title="Edit">
							<Button
								type="text"
								icon={<img src={editIcon} width={16} height={16} alt="edit" />}
								onClick={(e) => {
									e.stopPropagation();
									navigate('/comptroller/key-management-area/coe-kma', {
										state: { existingHierarchyNameMap, kmaDetails: cell.row.original, kmaList },
									});
								}}
							></Button>
						</Tooltip>
						<Tooltip title="Delete">
							<Button
								type="text"
								icon={<img src={deleteIcon} width={16} height={16} alt="delete" />}
								onClick={(e) => {
									e.stopPropagation();
									handleDelete({ id: cell.row.original?.id });
								}}
							></Button>
						</Tooltip>
					</div>
				),
				disableSortBy: 'true',
				align: 'center',
			},
		],
		[kmaList, moduleList, existingHierarchyNameMap]
	);

	return (
		<Spin spinning={isLoading}>
			<ComptrollerDataTable
				DATA={kmaList}
				onClickHandler={(row) => {
					// console.log(row);
					navigate('/comptroller/key-management-area/details', { state: { existingHierarchyNameMap, kmaDetails: row, kmaList } });
				}}
				COLUMNS={COLUMNS}
				xlsxFileName="solution-task"
			/>
		</Spin>
	);
};

export default ListViewKeyManagementArea;
